import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Spin, message } from 'antd';
import ModalItem from './ModalItem';

const DisponibilidadInsumoModal = ({ visible, onClose, insumoId, nombreInsumo, headersToken, empresaId, proyectoId }) => {
  const [loading, setLoading] = useState(false);
  const [proyectos, setProyectos] = useState([]);

  useEffect(() => {
    if (visible && insumoId) {
      consultarDisponibilidad();
    } else if (!visible) {
      setProyectos([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, insumoId]);

  const consultarDisponibilidad = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        'insumos/disponibilidadInsumo',
        { empresaId, insumoId },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        setProyectos(res.data.proyectos || []);
      } else {
        message.warning('No se pudo cargar la disponibilidad');
      }
    } catch {
      message.warning('No se pudo cargar la disponibilidad');
    } finally {
      setLoading(false);
    }
  };

  const thStyle = {
    padding: '6px 10px',
    background: '#f5f5f5',
    fontWeight: 600,
    fontSize: 11,
    color: '#374151',
    borderBottom: '1px solid #e5e7eb',
    whiteSpace: 'nowrap',
  };

  const tdStyle = (align = 'left') => ({
    padding: '5px 10px',
    fontSize: 12,
    color: '#111827',
    borderBottom: '1px solid #f3f4f6',
    textAlign: align,
  });

  const sinDatos = (cols) => (
    <tr>
      <td colSpan={cols} style={{ textAlign: 'center', padding: '10px', color: '#9ca3af', fontSize: 12 }}>
        Sin registros
      </td>
    </tr>
  );

  const subTabla = (titulo, color, cols, filas) => (
    <div style={{ marginBottom: 10 }}>
      <div style={{
        fontSize: 11,
        fontWeight: 700,
        color,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: 4,
        paddingLeft: 2,
      }}>
        {titulo}
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', border: `1px solid ${color}25` }}>
        <thead><tr>{cols.map((c, i) => <th key={i} style={{ ...thStyle, textAlign: c.align || 'left' }}>{c.label}</th>)}</tr></thead>
        <tbody>{filas}</tbody>
      </table>
    </div>
  );

  return (
    <ModalItem
      title={`Disponibilidad — ${nombreInsumo || ''}`}
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={950}
      spinning={false}
    >
      <Spin spinning={loading}>
        {proyectoId && (() => {
          const proy = proyectos.find(p => p._id?.toString() === proyectoId?.toString());
          return proy ? (
            <div style={{
              background: '#00BFD615',
              border: '1px solid #00BFD6',
              borderRadius: 8,
              padding: '8px 14px',
              marginBottom: 16,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}>
              <span style={{ fontSize: 12, color: '#005f6b' }}>Proyecto actual:</span>
              <strong style={{ fontSize: 13, color: '#005f6b' }}>{proy.nombre}</strong>
              <span style={{ marginLeft: 16, fontSize: 12, color: '#374151' }}>
                Disponible: <strong style={{ color: '#00BFD6' }}>{proy.disponible ?? 0}</strong>
              </span>
              <span style={{ fontSize: 12, color: '#374151' }}>
                Apartado: <strong style={{ color: '#f59e0b' }}>{proy.apartado ?? 0}</strong>
              </span>
            </div>
          ) : null;
        })()}
        {proyectos.length === 0 && !loading && (
          <div style={{ textAlign: 'center', padding: '32px 0', color: '#9ca3af' }}>Sin datos</div>
        )}
        {proyectos.map((proy, idx) => (
          <div
            key={idx}
            style={{
              marginBottom: 20,
              border: '1px solid #e5e7eb',
              borderRadius: 10,
              overflow: 'hidden',
            }}
          >
            {/* Header del proyecto */}
            <div style={{
              background: '#00BFD608',
              borderBottom: '2px solid #00BFD6',
              padding: '10px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
              <span style={{ fontWeight: 700, fontSize: 14, color: '#005f6b' }}>
                {proy.nombre}
              </span>
              <div style={{ display: 'flex', gap: 24 }}>
                <span style={{ fontSize: 13, color: '#374151' }}>
                  <span style={{ color: '#6b7280', marginRight: 4 }}>Disponible:</span>
                  <strong style={{ color: '#00BFD6' }}>{proy.disponible ?? 0}</strong>
                </span>
                <span style={{ fontSize: 13, color: '#374151' }}>
                  <span style={{ color: '#6b7280', marginRight: 4 }}>Apartado:</span>
                  <strong style={{ color: '#f59e0b' }}>{proy.apartado ?? 0}</strong>
                </span>
              </div>
            </div>

            {/* Sub-tablas */}
            <div style={{ padding: '12px 16px' }}>

              {/* Órdenes de compra */}
              {subTabla('Órdenes de Compra Pendientes', '#10b981',
                [{ label: 'Folio' }, { label: 'Proveedor' }, { label: 'Cantidad', align: 'right' }, { label: 'Recibido', align: 'right' }, { label: 'Pendiente', align: 'right' }],
                (proy.ordenesCompra?.length > 0)
                  ? proy.ordenesCompra.map((o, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f0fdf4' }}>
                      <td style={tdStyle()}>{o.folio}</td>
                      <td style={tdStyle()}>{o.proveedor}</td>
                      <td style={tdStyle('right')}>{o.cantidad}</td>
                      <td style={tdStyle('right')}>{o.recibido}</td>
                      <td style={tdStyle('right')}>{o.pendiente}</td>
                    </tr>
                  ))
                  : sinDatos(5)
              )}

              {/* Pedidos */}
              {subTabla('Pedidos Pendientes', '#f59e0b',
                [{ label: 'Folio' }, { label: 'Cliente' }, { label: 'Cantidad', align: 'right' }, { label: 'Vendido', align: 'right' }, { label: 'Apartado', align: 'right' }, { label: 'Pendiente', align: 'right' }],
                (proy.pedidos?.length > 0)
                  ? proy.pedidos.map((p, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fffbf0' }}>
                      <td style={tdStyle()}>{p.folio}</td>
                      <td style={tdStyle()}>{p.cliente}</td>
                      <td style={tdStyle('right')}>{p.cantidad}</td>
                      <td style={tdStyle('right')}>{p.vendido}</td>
                      <td style={tdStyle('right')}>{p.apartado}</td>
                      <td style={tdStyle('right')}>{p.pendiente}</td>
                    </tr>
                  ))
                  : sinDatos(6)
              )}

              {/* Ventas sin entregar */}
              {subTabla('Ventas Sin Entregar', '#ef4444',
                [{ label: 'Folio' }, { label: 'Cliente' }, { label: 'Cantidad', align: 'right' }, { label: 'Entregado', align: 'right' }, { label: 'Pendiente', align: 'right' }],
                (proy.ventasSinEntregar?.length > 0)
                  ? proy.ventasSinEntregar.map((v, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fef2f2' }}>
                      <td style={tdStyle()}>{v.folio}</td>
                      <td style={tdStyle()}>{v.cliente}</td>
                      <td style={tdStyle('right')}>{v.cantidad}</td>
                      <td style={tdStyle('right')}>{v.entregado}</td>
                      <td style={tdStyle('right')}>{v.pendiente}</td>
                    </tr>
                  ))
                  : sinDatos(5)
              )}

            </div>
          </div>
        ))}
      </Spin>
    </ModalItem>
  );
};

export default DisponibilidadInsumoModal;
